import reqLib from 'request';
import fs from 'fs';
import util from 'util';
import jsdom from 'jsdom';

const DOMParser = jsdom.jsdom().defaultView.DOMParser;

const defaultLog = (title, obj) => {
  console.log(`\n-------------------------\n${title}\n-------------------------`);
  console.log(util.inspect(obj, {
    depth: 4,
    colors: true,
  }));
};

const parseResponse = (res, isDownload) => ({
  status: res.statusCode,
  statusText: res.statusMessage,
  headers: res.headers,
  body: isDownload ? '' : res.body.toString(),
});

/**
 * @typedef requestCallback
 * @type {function}
 * @description Executes http request.
 * @param {object} config http request configuration
 * @param {string} config.url target url
 * @param {string} config.method http method
 * @param {object} config.query http param query hash
 * @param {object} config.headers headers hash
 * @param {string} config.importFile path of the file to upload
 * @param {string} config.exportFile path of the file to download to
 * @param {string} config.formField name of the form field for upload
 * @param {string} payload xml string or path of xml file to sent as request body
 * @returns {Response} response object
 */
const request = log => (config, payload) => {
  const options = {
    uri: config.url,
    method: config.method,
    headers: config.headers,
    body: payload,
    qs: config.query,
    gzip: true,
  };

  if (config.importFile) {
    options.headers = Object.assign({}, options.headers, {
      'Content-Type': 'multipart/form-data',
      Connection: 'keep-alive',
    });
    log('Request Configuration',
      Object.assign({}, options, { formField: config.formField, importFile: config.importFile }));
    options.formData = {};
    options.formData[config.formField] = fs.createReadStream(config.importFile);
  } else {
    log('Request Configuration',
      Object.assign({}, options, { exportFile: config.exportFile }));
  }

  const isDownload = config.exportFile !== undefined;
  return new Promise((resolve, reject) => {
    const req = reqLib(options, (err, res) => {
      if (err) reject(err);
      else {
        resolve(parseResponse(res, isDownload));
      }
    });
    if (isDownload) req.pipe(fs.createWriteStream(config.exportFile));
  });
};

const btoa = str => new Buffer(str, 'utf8').toString('base64');

/**
 * @name default
 * @type {function}
 * @param {?function} logFunction function to use for logging
 * @returns NodeJSAdapter Adapter API
 */
export default logFunction => {
  const log = logFunction || defaultLog;
  return {
    request: request(log),
    log,
    btoa,
    DOMParser,
  };
};

/**
 * @typedef NodeJSAdapter
 * @type {object}
 * @property {requestCallback} request http request method
 * @property {logCallback} log log method
 * @property {btoaCallback} btoa base64 string convert method
 * @property {DOMParser} DOMParser DOMParser API
 */

/**
 * @typedef logCallback
 * @type {function}
 * @description logs message with header
 * @param {string} header title of the message
 * @param {string} message message to log
 */

/**
 * @typedef btoaCallback
 * @type {function}
 * @description returns a base-64 encoded ASCII string from a String object
 * @param {string} string to encode
 * @returns {string} encodedString
 */

/**
 * @typedef Response
 * @type {object}
 * @property {number} status http status code
 * @property {string} statusText http status text
 * @property {object} headers http response headers
 * @property {string} body http response body
 */

